var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('v-layout',{staticStyle:{"padding":"1em"},attrs:{"justify-center":"","column":"","fill-height":""}},[_c('AccountInformation')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }